import { useQuery } from '@tanstack/react-query';
import { getCompanies, getInvoiceFinancingCompanies } from '../services/companyUsers';
import { PaginatedResponse } from '../services/types';
import {
  CompanyAdminFilters,
  CompanyAdminResult,
  InvoiceFinancingCompanyAdminFilters,
  InvoiceFinancingCompanyAdminResult,
} from '../types/companyUser';

export const COMPANIES_QUERY_KEY = 'companies';
export const INVOICE_FINANCING_COMPANIES_QUERY_KEY = 'invoice-financing-companies';

export const useCompanies = (filters: CompanyAdminFilters, onError: (errorCode?: string) => void) => {
  return useQuery<PaginatedResponse<CompanyAdminResult>>({
    queryKey: [
      COMPANIES_QUERY_KEY,
      filters.company,
      filters.ordering,
      filters.products,
      filters.subProducts,
      filters.page,
      filters.pageSize,
    ],
    queryFn: () => getCompanies(filters),
    onError: (error) => {
      const errorCode = (error as any)?.response?.data?.error_code || 'unknown';
      onError(errorCode);
    },
  });
};

export const useInvoiceFinancingCompanies = (
  filters: InvoiceFinancingCompanyAdminFilters,
  onError: (errorCode?: string) => void
) => {
  return useQuery<PaginatedResponse<InvoiceFinancingCompanyAdminResult>>({
    queryKey: [
      INVOICE_FINANCING_COMPANIES_QUERY_KEY,
      filters.company,
      filters.ordering,
      filters.status,
      filters.deletedOnly,
      filters.page,
      filters.pageSize,
    ],
    queryFn: () => getInvoiceFinancingCompanies(filters),
    onError: (error) => {
      const errorCode = (error as any)?.response?.data?.error_code || 'unknown';
      onError(errorCode);
    },
  });
};
